import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup } from "@/src/common/components/ui/toggle-button-group";
import { useAppDispatch, useAppSelector } from "@/src/common/redux/store";
import { getColorSchemePreference } from "@/src/common/store/general-selectors";
import { type ColorSchemePreference, setColorSchemePreference } from "@/src/common/store/general-slice";

const MODES: readonly {
	id: ColorSchemePreference;
	icon: typeof Sun;
	labelKey: "top_bar.theme.light" | "top_bar.theme.dark" | "top_bar.theme.system";
}[] = [
	{ id: "light", icon: Sun, labelKey: "top_bar.theme.light" },
	{ id: "dark", icon: Moon, labelKey: "top_bar.theme.dark" },
	{ id: "system", icon: Monitor, labelKey: "top_bar.theme.system" },
];

export function ThemeSwitcher() {
	const { t } = useTranslation("common");
	const dispatch = useAppDispatch();
	const preference = useAppSelector(getColorSchemePreference);

	return (
		<div className="flex flex-col gap-1.5 px-3 py-2">
			<span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{t("top_bar.theme.label")}</span>
			<ToggleButtonGroup
				fullWidth
				size="sm"
				selectionMode="single"
				disallowEmptySelection
				selectedKeys={new Set([preference])}
				onSelectionChange={(keys) => {
					const next = [...keys][0] as ColorSchemePreference | undefined;
					if (next) dispatch(setColorSchemePreference(next));
				}}
			>
				{MODES.map((mode) => {
					const Icon = mode.icon;
					return (
						<ToggleButton key={mode.id} id={mode.id} aria-label={t(mode.labelKey)}>
							<ToggleButtonGroup.Separator />
							<Icon className="size-4" aria-hidden />
							<span className="text-xs">{t(mode.labelKey)}</span>
						</ToggleButton>
					);
				})}
			</ToggleButtonGroup>
		</div>
	);
}
